import React, { FunctionComponent, KeyboardEvent } from 'react';
import type { SearchFormOptions } from '../../../types/recruitments';
import { ModalCheckBox } from '../../atoms/modalCheckBox';
import { FlashBox } from '../../atoms/flashBox';
import { LoginModal } from '../loginModal';
import { RegisterModal } from '../registerModal';

type Props = {
  lineIcon: string;
  isRecruitmentShowPage: boolean;
  requestUrl: string;
  logoPc: string;
  logoSp: string;
  isVantan: boolean;
  isSearchPage: boolean;
  searchFormOptions: SearchFormOptions;
  isModalOpen: boolean;
  query: string;
  targetEmploymentTypes: any;
  targetOccupations: any;
  targetPrefectureDetails: any;
  isLoginModalOpen: boolean;
  isRegisterModalOpen: boolean;
  redirectUrl: string;
  isLoginError?: boolean;
  modalFlashMessage?: string;
  handleChangeQuery: (event: any) => void;
  handleClick: (event: any) => void;
  handleClear: (event: any) => void;
  handleMenuPlan: (event: any) => void;
  handleToggleModal: () => void;
  handleToggleLoginModal: () => void;
  handleToggleRegisterModal: () => void;
  handleChangeModal: (from: 'login' | 'register') => void;
  isRecruitmentOrEventOrTvOrCompanyPath: () => boolean;
  flash: boolean;
  flashType: string;
  flashMessage: string;
  handleFlash: (flash: boolean, flashType: string, flashMessage: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  lineIcon,
  isRecruitmentShowPage,
  requestUrl,
  logoPc,
  logoSp,
  isVantan,
  isSearchPage,
  searchFormOptions,
  isModalOpen,
  query,
  targetEmploymentTypes,
  targetOccupations,
  targetPrefectureDetails,
  isLoginModalOpen,
  isRegisterModalOpen,
  redirectUrl,
  isLoginError,
  modalFlashMessage,
  handleChangeQuery,
  handleClick,
  handleClear,
  handleMenuPlan,
  handleToggleModal,
  handleToggleLoginModal,
  handleToggleRegisterModal,
  handleChangeModal,
  isRecruitmentOrEventOrTvOrCompanyPath,
  flash,
  flashType,
  flashMessage,
  handleFlash,
}) => {
  const handleConfirmKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return;

    event.preventDefault();
    event.currentTarget.blur();
  };

  return (
    <>
      <FlashBox
        flash={flash}
        flashType={flashType}
        flashMessage={flashMessage}
        handleFlash={handleFlash}
      />
      <header className="l-header l-header-responsive js-outer-height u-clear">
        <div className="l-header-logo">
          {requestUrl === 'https://www.readytofashion.jp/' && (
            <>
              <a href="/">
                <h1 className="l-header-logo-link pc-logo">
                  <picture>
                    <source srcSet={logoPc} media="(min-width: 1380px)" />
                    <img
                      src={logoSp}
                      className="l-header-logo-img unlogged"
                      alt="ファッション・アパレルの求人・転職 READY TO FASHION"
                    />
                  </picture>
                </h1>
              </a>
              <a href="/">
                <h1 className="l-header-logo-link sp-logo">
                  <img
                    src={logoSp}
                    className="l-header-logo-img unlogged"
                    alt="ファッション・アパレルの求人・転職 READY TO FASHION"
                  />
                </h1>
              </a>
            </>
          )}
          {requestUrl !== 'https://www.readytofashion.jp/' && (
            <>
              <a className="l-header-logo-link pc-logo" href="/">
                <picture>
                  <source srcSet={logoPc} media="(min-width: 1380px)" />
                  <img
                    src={logoSp}
                    className="l-header-logo-img unlogged"
                    alt="ファッション・アパレルの求人・転職 READY TO FASHION"
                  />
                </picture>
              </a>
              <a className="l-header-logo-link sp-logo" href="/">
                <img
                  src={logoSp}
                  className="l-header-logo-img unlogged"
                  alt="ファッション・アパレルの求人・転職 READY TO FASHION"
                />
              </a>
            </>
          )}
        </div>
        <nav className="l-header-nav">
          <ul className="l-header-nav-inner">
            <li className="l-header-nav-item">
              <a href="/search" className="l-header-nav-link-blur">
                求人
              </a>
            </li>
            <li className="l-header-nav-item">
              <a href="/brands" className="l-header-nav-link-blur">
                ブランド
              </a>
            </li>
            <li className="l-header-nav-item">
              <a href="/events" className="l-header-nav-link-blur">
                イベント
              </a>
            </li>
            <li className="l-header-nav-item">
              <a href="/companies" className="l-header-nav-link-blur">
                会社
              </a>
            </li>
            <li className="l-header-nav-item">
              <a href="/tvs" className="l-header-nav-link-blur">
                動画
              </a>
            </li>
            <li className="l-header-nav-item">
              <a href="/recruitment_browsing_histories" className="l-header-nav-link-blur">
                閲覧履歴
              </a>
            </li>
            <li className="l-header-nav-item">
              <a href="/favorite_recruitments" className="l-header-nav-link-blur">
                保存済み
              </a>
            </li>
            <li className="l-header-nav-item">
              <a href="/mag/" className="l-header-nav-link-blur">
                マガジン
              </a>
            </li>
            <li className="l-header-nav-item">
              <form action="/search" method="get" acceptCharset="UTF-8" className="l-header-nav-search">
                <input type="text" name="q" id="q" className="l-header-nav-search-form" placeholder="求人を検索" />
              </form>
            </li>
          </ul>
        </nav>
        <div className="l-header-login l-header-login-common l-header-login-forrecruiter">
          <ul className="l-header-login-menu"></ul>
        </div>
        <div className="l-header-login l-header-login-common l-header-login-forrecruiter">
          <ul className="l-header-login-menu">
            <li>
              {!isVantan && (
                <a className="l-header-button btn btn-forrecruiter" href="https://jinji.readytofashion.jp/service" id="">
                  <span className="btn-inner">採用担当者の方へ</span>
                </a>
              )}
            </li>
            <li>
              <a onClick={handleToggleRegisterModal} className="l-header-button btn new js-top-user-registration" id="">
                <span className="btn-inner">新規登録</span>
              </a>
            </li>
            <li>
              <a onClick={handleToggleLoginModal} className="l-header-button btn login js-top-user-login" id="">
                <span className="btn-inner">ログイン</span>
              </a>
            </li>
          </ul>
        </div>
        <div className="l-header-spmenu ">
          <ul className="flexBox">
            {!isSearchPage && (
              <li className="l-header-spmenu__list">
                <a className="l-header-spmenu__list search" href="#" onClick={handleToggleModal}>
                  <span>
                    <i className="fas fa-search"></i>
                  </span>
                </a>
              </li>
            )}
            <li className="l-header-spmenu__list">
              <a
                onClick={handleToggleRegisterModal}
                className="l-header-spmenu__list registration js-top-user-registration"
                id=""
              >
                <span>新規登録</span>
              </a>
            </li>
          </ul>
        </div>
        {!isRecruitmentShowPage && (
          <aside className="l-spbottom gtm-navigation-view-count" id="js-l-spmenu" data-event-name='navigation on screen' data-category="not_login_tabBar" data-value='navigation'>
            <ul>
              <li>
                <a href="/search" data-event="click" data-category="not_login_tabBar" data-value="recruitment">
                  <span className="material-symbols-outlined">wysiwyg</span>
                  <span>求人</span>
                </a>
              </li>
              <li>
                <a href="/events" data-event="click" data-category="not_login_tabBar" data-value="event">
                  <span className="material-symbols-outlined">calendar_today</span>
                  <span>イベント</span>
                </a>
              </li>
              <li>
                <a href="/favorite_recruitments" data-event="click" data-category="not_login_tabBar" data-value="favorite_recruitments">
                  <span className="material-symbols-outlined">bookmark</span>
                  <span>保存済み</span>
                </a>
              </li>
              <li>
                <a href="/recruitment_browsing_histories" data-event="click" data-category="not_login_tabBar" data-value="browsing_history">
                  <span className="material-symbols-outlined">overview</span>
                  <span>閲覧履歴</span>
                </a>
              </li>
              <li>
                <a onClick={handleMenuPlan} className="js-top-user-login" data-event="click" data-category="not_login_tabBar" data-value="login">
                  <span className="material-symbols-outlined">login</span>
                  <span>ログイン</span>
                </a>
              </li>
            </ul>
          </aside>
        )}
      </header>
      <div className={`l-header__unloggedModal ${isModalOpen && 'active'}`}>
        <div className="l-header__unloggedModal__heading">
          <span className="cancel" onClick={handleToggleModal}></span>
          <p className="title">求人検索</p>
        </div>
        <div className="l-header__unloggedModal__wrapper">
          <div className="l-header__unloggedModal__wrapper__keyword">
            <p className="title">キーワード / タグ</p>
            <input
              value={query}
              type="text"
              name="q"
              onChange={handleChangeQuery}
              className="q"
              placeholder="キーワードで探す"
              autoComplete="off"
              enterKeyHint="done"
              onKeyDown={handleConfirmKeyDown}
            />
          </div>
          {searchFormOptions.recruitment_employment_types &&
            searchFormOptions.recruitment_employment_types.length > 0 && (
              <ModalCheckBox
                title="雇用形態"
                name="target_employment_types"
                items={searchFormOptions.recruitment_employment_types}
                handleClick={handleClick}
                targets={targetEmploymentTypes}
              />
            )}
          {searchFormOptions.occupations && searchFormOptions.occupations.length > 0 && (
            <ModalCheckBox
              title="職種"
              name="target_occupations"
              items={searchFormOptions.occupations}
              handleClick={handleClick}
              targets={targetOccupations}
            />
          )}
          {searchFormOptions.all_prefectures && searchFormOptions.all_prefectures.length > 0 && (
            <ModalCheckBox
              title="勤務地"
              name="target_prefecture_details"
              items={searchFormOptions.all_prefectures}
              handleClick={handleClick}
              targets={targetPrefectureDetails}
            />
          )}
        </div>
        <div className="l-header__unloggedModal__bottom">
          <p onClick={handleClear} className="clear">
            すべてクリア
          </p>
          <a
            href={`/search?q=${query}&occupation_id=${targetOccupations}&employment_type=${targetEmploymentTypes}&prefecture_ids=${targetPrefectureDetails}`}
            className="searchBtn"
          >
            検索
          </a>
        </div>
      </div>
      <LoginModal
        isModalOpen={isLoginModalOpen}
        redirectUrl={redirectUrl}
        isLoginError={isLoginError}
        flashMessage={modalFlashMessage}
        fromButton="header"
        handleToggleLoginModal={handleToggleLoginModal}
        handleChangeModal={handleChangeModal}
        lineIcon={lineIcon}
      />
      <RegisterModal
        isModalOpen={isRegisterModalOpen}
        redirectUrl={redirectUrl}
        isRequestPathRecruitmentOrEventOrTvOrFollow={isRecruitmentOrEventOrTvOrCompanyPath()}
        isCarefully={true}
        handleToggleRegisterModal={handleToggleRegisterModal}
        handleChangeModal={handleChangeModal}
        lineIcon={lineIcon}
      />
    </>
  );
};
